import RequestAdmin from '../config/Request/requestAdmin';
export function VerifyAdmin(data) {
  return RequestAdmin({
    url: '/Admin/AdminVerify',
    method: 'POST',
    data: data,
  });
}
